// Check if we're running in Electron
const isElectron = window && window.process && window.process.type;

// Function to show loading
export function showLoading() {
    if (isElectron) {
        window.electron.send('show-loading');
    }
}

// Function to hide loading
export function hideLoading() {
    if (isElectron) {
        window.electron.send('hide-loading');
    }
}

// Intercept Livewire requests
document.addEventListener('livewire:init', () => {
    // Show loading when a request starts
    Livewire.hook('request', ({ uri, options, payload, respond, succeed, fail }) => {
        showLoading();
        
        // Hide loading when the request completes (success or failure)
        succeed(({ status, json }) => {
            hideLoading();
            return { status, json };
        });

        fail(({ status, content, preventDefault }) => {
            hideLoading();
            return { status, content, preventDefault };
        });
    });
});

// Also handle Filament requests
document.addEventListener('filament:init', () => {
    // Show loading when a Filament request starts
    document.addEventListener('filament:request-started', () => {
        showLoading();
    });

    // Hide loading when a Filament request completes
    document.addEventListener('filament:request-completed', () => {
        hideLoading();
    });
}); 